function Beer() {
  return (
    <svg width="320" height="320" viewBox="0 0 320 320" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="320" height="320" rx="3" fill="#404045" />
      <circle cx="159.999" cy="160" r="113.171" fill="white" />
      <mask id="mask0_10164_43744" mask="alpha" maskUnits="userSpaceOnUse" x="46" y="46" width="228" height="228">
        <circle cx="159.999" cy="160" r="113.171" fill="white" />
      </mask>
      <g mask="url(#mask0_10164_43744)" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M182.862 108.011C182.929 96.0569 174.346 87 163.825 87C155.224 87 147.953 92.7041 145.395 100.867C142.601 98.4617 138.92 96.7489 134.839 96.7489C130.683 96.7489 126.827 98.4137 124.275 101.627C121.718 98.7293 117.806 96.7489 113.293 96.7489C105.396 96.7489 99 103.145 99 111.036C99 118.933 105.396 125.329 113.293 125.329H133.047C133.047 135.54 138.77 145.137 152.091 145.137V156.193C152.091 167.856 171.14 167.449 171.14 156.193V125.329H189.333C194.593 125.329 198.858 121.065 198.858 115.804C198.858 110.538 194.594 106.273 189.333 106.273C186.769 106.273 184.188 107.081 182.864 108.01L182.862 108.011Z"
        fill="#FFBF17"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M187.03 132.158V143.22H204.014C213.356 143.22 220.999 150.861 220.999 160.204V199.402C220.999 208.744 213.357 216.386 204.014 216.386H187.03V217.498C187.03 225.552 180.439 232.144 172.383 232.144H125.472C117.417 232.144 110.832 225.553 110.832 217.498V132.019C111.634 132.11 112.46 132.158 113.292 132.158H126.923C129 141.817 135.579 148.948 145.256 151.208V156.195C145.256 170.968 163.528 176.271 173.277 167.184C176.369 164.305 177.967 160.41 177.967 156.195V132.158H187.03L187.03 132.158ZM187.03 157.404V202.202H201.954C204.761 202.202 207.057 199.907 207.057 197.1V162.506C207.057 159.699 204.761 157.403 201.954 157.403L187.03 157.404Z"
        fill="#FFBF17"
      />
    </svg>
  );
}

export default Beer;
